import { useIntl } from "react-intl"
import styled from "styled-components"
import IconFactory from "UI/IconFactory"

const AppStoreWrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`

const APP_STORE_URL = "https://apps.apple.com/se/app/brocc/id6473739495"
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.broccfinanceab.brocc"

export const AppStoreLinks = () => {
  const intl = useIntl()

  return (
    <AppStoreWrap>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={intl.formatMessage({
          id: "app.onboarding.followApplication.appStore.label",
          defaultMessage: "Brocc på App Store",
        })}
      >
        <IconFactory name="appStoreIcon" />
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={intl.formatMessage({
          id: "app.onboarding.followApplication.googlePlay.label",
          defaultMessage: "Brocc på Google Play",
        })}
      >
        <IconFactory name="googlePlayIcon" />
      </a>
    </AppStoreWrap>
  )
}
